
<script>
   export let ident;
   export let main;
   //export let prerequisites;
   export let prerequisitesPolicy;
   export let pointsValue;

   import Store from '../stores/Store';

   import { meetsRequirements } from '../global.js';

   let enable = true;

   let checked = false;

   function pushToStore() {
      Store.update(data => {data[ident] = enable * checked; return data;});
      //console.log(checked);
   }

   if (prerequisitesPolicy)
      Store.subscribe(data => {
         const oldEnableState = enable;
         enable = meetsRequirements(data,prerequisitesPolicy);
         if (oldEnableState != enable)
            pushToStore();
      });
</script>

<li class="list-group-item">
   <div class="form-check">
      <input class="form-check-input" type="checkbox" value="" id={ident} disabled={!enable} bind:checked={checked} on:change={pushToStore}>
      <label class="form-check-label" for={ident}>
         <small class='float-end fw-light opacity-75'>{pointsValue} points</small>
        {main}
      </label>
    </div>
</li>

<style>
   .form-check > label {
      min-width: 100%;
   }
</style>
